import React, {FC, useState} from 'react';
import {
  GxButton,
  GxCheckbox,
  GxDropdown,
  GxIcon,
  GxMenu,
  GxMenuDivider,
  GxMenuItem,
  GxSelect,
} from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import {useMediaQuery} from 'react-responsive';
import {useStoreon} from 'storeon/react';
import {toast} from 'react-toastify';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss';
import {
  AccountCheckIcon,
  CalendarIcon,
  CloseIcon,
  CollapseIcon,
  DeleteChecked,
  DeleteIcon,
  ExpandIcon,
  PencilIcon,
  PlusIcon,
  PrinterIcon,
  SettingsIcon,
} from '../../../../assets';
import ModalOrder from '../ModalOrder';
import {TypeRange, TypeTable} from '../../interfaces';
import {countCheckedOrders, showErrMessageCreateUser} from '../../helpers';
import useModalFlag from '../../../../hooks/useModalFlag';
import {getOrdersId, handleClickIsPrint} from './helpers';
import ToastInfoContract from '../../../../components/ToastInfoContract';
import {NAME_STATUS_API_ORDER} from '../../consts';
import {MODALS_NAMES} from '../../../../const/modals';
import useModal from '../../../../hooks/useModal';
import SelectUser from '../../../../components/SelectUsers/Select';
import Switcher from '../../../../components/Switcher';
import {TYPE_USER} from '../../../../const';

interface IScheduleHeader {
  onChangeRange: (type: TypeRange) => void;
  onChangeTypeTable: (type: TypeTable) => void;
  typeTable: TypeTable;
  rangeTableType: TypeRange;
}

const ScheduleHeader: FC<IScheduleHeader> = ({
  onChangeRange,
  onChangeTypeTable,
  typeTable,
  rangeTableType,
}) => {
  const isLaptop = useMediaQuery({
    query: '(min-width: 1201px)',
  });
  const { openModal } = useModal();
  const { flag: orderModalOpen, setModalFlag: toggleFlag } = useModalFlag();
  const [range, setRange] = useState<TypeRange>('day');
  const {
    dispatch,
    ordersDay,
    currentUser,
    selectedUser,
    ordersInfo,
    statusGetOrders,
  } = useStoreon<State, Events>(
    'selectedUser',
    'ordersInfo',
    'currentUser',
    'ordersDay',
    'statusGetOrders'
  );
  const openModalUser = (): void => {
    openModal(MODALS_NAMES.modalUser, { isEdit: false });
  };

  const openModalUserEdit = (): void => {
    openModal(MODALS_NAMES.modalUser, {
      isEdit: true,
      userId: selectedUser?.id,
    });
  };

  const handleClickActiveOrder = (e: Record<string, any>) => {
    dispatch('ordersInfo/set', {
      is_show_all_order_statuses: e.target.checked,
    });
    dispatch('orders/get');
  };

  const handleClickRange = (e: Record<string, any>) => {
    setRange(e.target.value);
    onChangeRange(e.target.value);
    dispatch('ordersInfo/set', { range: e.target.value });
    dispatch('orders/get');
  };
  const handleClickCreateOrders = () => {
    toggleFlag();
    dispatch('statusCreateMultiOrders/set', true);
  };
  const handleClickDeleteOrder = () => {
    ordersDay.forEach((item) =>
      item[1].orders.forEach((order: Record<string, any>) => {
        if (order.checked && order.id) {
          if (order.id) {
            toast.promise(
              api.order.updateOrders(order.id, { status: 1 })
                .then(() => {
                  dispatch('orders/get');
                }),
              {
                pending: 'Идет обновление заявки...',
                // success: `Заявка ${order.id}, успешно удалена!`,
                error: {
                  render(res: Record<string, any>) {
                    const { data, status } = res.data.response;
                    if (
                      status === 500 ||
                      status === 501 ||
                      status === 502 ||
                      status === 503
                    ) {
                      return (
                        NAME_STATUS_API_ORDER.CREATE.USER.ERROR_500 + status
                      );
                    }
                    if (
                      (data && status !== 500) ||
                      status !== 501 ||
                      status !== 502 ||
                      status !== 503
                    ) {
                      showErrMessageCreateUser(data);
                    }
                    return `Ошибка удаления ${order.id} заявки!`;
                  },
                },
              }
            );
          }
        }
      })
    );
  };
  const handleClickIsArrived = () => {
    ordersDay.forEach((item) =>
      item[1].orders.forEach((order: Record<string, any>) => {
        if (order.checked && order.id) {
          toast
            .promise(
              api.order.updateOrders(order.id, { is_arrived: true}),
              {
                pending: 'Идет обновление заявки...',
                success: `Статус прибытия заявки ${order.id}, успешно изменен!`,
                error: `Ошибка изменения статуса прибытия ${order.id} заявки!`,
              }
            )
            .then(() => {
              dispatch('orders/get');
            });
        }
      })
    );
  };

  const handleClickCloseAndCancelOrder = (type: string) => {
    ordersDay.forEach((item) =>
      item[1].orders.forEach((order: Record<string, any>) => {
        if (order.checked && order.id) {
          if (order.id) {
            toast.promise(
              api.order.updateOrders(order.id, {
                  status: type === 'close' ? 8 : 1,
                })
                .then(
                  () => {
                    dispatch('orders/get');
                  },
                  (err) => {
                    toast.error(
                      `Заявка ${order.id}: ${err.response.data.non_field_errors[0]}`
                    );
                  }
                ),
              {
                pending: 'Идет обновление заявки...',
              }
            );
          }
        }
      })
    );
  };

  const print = async () => {
    const arr = await handleClickIsPrint(getOrdersId(ordersDay));
    arr.contract_pages.forEach((item) => {
      toast(<ToastInfoContract data={item} />, {
        position: 'top-right',
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        data: item,
      });
    });
  };

  return (
    <>
      {!isLaptop ? (
        <div className={styles['header']}>
          {currentUser.user_status !== TYPE_USER.VIEWER && (
            <div className={styles['header--left_block']}>
              {rangeTableType !== 'week' && (
                <div className={styles['multi-checkbox']}>
                  <GxCheckbox
                    name='multi-checkbox'
                    checked={countCheckedOrders(ordersDay) !== 0}
                    onGx-change={() =>
                      dispatch(
                        'changeCheckedOrder/set',
                        countCheckedOrders(ordersDay) !== 0 ? 'takeOf' : 'all'
                      )
                    }
                  />
                  <span className={styles['multi-checkbox--count']}>
                    {countCheckedOrders(ordersDay)}
                  </span>
                </div>
              )}
            </div>
          )}
          <div className={styles['header__right-block']}>
            <div className={styles['select']}>
              <GxIcon className={styles['icon']} src={CalendarIcon} />
              <GxSelect
                disabled={statusGetOrders}
                value={range}
                className={styles['select--dropdown']}
                onGx-change={(e: Record<string, any>) => {
                  handleClickRange(e);
                }}
              >
                <GxMenuItem value='day' active>
                  1 день
                </GxMenuItem>
                <GxMenuItem value='week'>7 дней</GxMenuItem>
              </GxSelect>
            </div>
            <GxDropdown
              className={styles['dropdown_mobile']}
              distance={12}
              hoist
              closeOnSelect={false}
            >
              <GxIcon
                  src={SettingsIcon}
                  className={cn(
                      styles['icon'],
                      styles['icon--focus'],
                      styles['icon--dropdown']
                  )}
                  slot='trigger'
              />
              <GxMenuItem
                  className={cn(
                      styles['dropdown_mobile--menu-item'],
                      styles['search']
                  )}
                  disabled
              >
                <SelectUser/>
              </GxMenuItem>

              <GxMenu className={styles['dropdown_mobile--menu']}>
                <GxMenuItem
                    className={cn(
                        styles['dropdown_mobile--menu-item'],
                        styles['search']
                    )}
                    onClick={openModalUser}
                >
                  <Switcher
                      label={
                        !ordersInfo.is_show_all_order_statuses
                            ? 'Активные'
                            : 'Все'
                      }
                      onGx-change={handleClickActiveOrder}
                      checked={ordersInfo.is_show_all_order_statuses}
                      className={styles['switcher']}
                  />
                </GxMenuItem>
                <GxMenuItem
                  className={styles['dropdown_mobile--menu-item']}
                  disabled={!selectedUser?.id}
                  onClick={openModalUserEdit}
                >
                  <GxIcon
                    src={PlusIcon}
                    className={cn(styles['icon'], styles['icon--dropdown'])}
                  />
                  <span>Просмотреть</span>
                </GxMenuItem>
                {currentUser.user_status !== TYPE_USER.VIEWER && (
                  <GxMenuItem
                    className={styles['dropdown_mobile--menu-item']}
                    onClick={openModalUser}
                  >
                    <GxIcon
                      src={PlusIcon}
                      className={cn(styles['icon'], styles['icon--dropdown'])}
                    />
                    <span>Новый пользователь</span>
                  </GxMenuItem>
                )}
                {currentUser.user_status !== TYPE_USER.VIEWER && (
                  <GxMenuItem
                    className={styles['dropdown_mobile--menu-item']}
                    onClick={handleClickCreateOrders}
                  >
                    <GxIcon
                      src={PencilIcon}
                      className={cn(styles['icon'], styles['icon--dropdown'])}
                    />
                    <span>Создать запись</span>
                  </GxMenuItem>
                )}
                {rangeTableType !== 'week' && (
                  <>
                    <GxMenuDivider />
                    <span className={styles['dropdown_mobile--subtitle']}>
                      Действия
                    </span>
                    <GxMenuDivider />
                    {currentUser.user_status !== TYPE_USER.VIEWER && (
                      <>
                        <GxMenuItem
                          className={styles['dropdown_mobile--menu-item']}
                          onClick={() =>
                            dispatch('changeCheckedOrder/set', 'takeOf')
                          }
                        >
                          <GxIcon
                            src={DeleteChecked}
                            className={cn(
                              styles['icon'],
                              styles['icon--dropdown']
                            )}
                          />
                          <span>Снять выделенное</span>
                        </GxMenuItem>

                        <GxMenuItem
                          className={styles['dropdown_mobile--menu-item']}
                          onClick={print}
                        >
                          <GxIcon
                            src={PrinterIcon}
                            className={cn(
                              styles['icon'],
                              styles['icon--dropdown']
                            )}
                          />
                          <span>Печать</span>
                        </GxMenuItem>
                        <GxMenuItem
                          className={styles['dropdown_mobile--menu-item']}
                          onClick={() =>
                            handleClickCloseAndCancelOrder('close')
                          }
                        >
                          <GxIcon
                            src={CloseIcon}
                            className={cn(
                              styles['icon'],
                              styles['icon--dropdown']
                            )}
                          />
                          <span>Закрыть</span>
                        </GxMenuItem>
                        <GxMenuItem
                          className={styles['dropdown_mobile--menu-item']}
                          onClick={handleClickIsArrived}
                        >
                          <GxIcon
                            src={AccountCheckIcon}
                            className={cn(
                              styles['icon'],
                              styles['icon--dropdown']
                            )}
                          />
                          <span>Прибыл</span>
                        </GxMenuItem>
                      </>
                    )}
                  </>
                )}
              </GxMenu>
            </GxDropdown>
            {rangeTableType === 'week' && (
              <>
                {typeTable === 'default' ? (
                  <GxIcon
                    src={CollapseIcon}
                    className={cn(styles['icon'], styles['icon--focus'])}
                    onClick={() => onChangeTypeTable('compact')}
                  />
                ) : (
                  <GxIcon
                    src={ExpandIcon}
                    className={cn(styles['icon'], styles['icon--focus'])}
                    onClick={() => onChangeTypeTable('default')}
                  />
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className={styles['header']}>
          <div className={styles['header--left_block']}>
            {currentUser.user_status !== TYPE_USER.VIEWER && (
              <>
                {rangeTableType !== 'week' && (
                  <>
                    <div className={styles['multi-checkbox']}>
                      <GxCheckbox
                        name='multi-checkbox'
                        checked={countCheckedOrders(ordersDay) !== 0}
                        onGx-change={() =>
                          dispatch(
                            'changeCheckedOrder/set',
                            countCheckedOrders(ordersDay) !== 0 ? 'takeOf' : 'all'
                          )
                        }
                      />
                      <span className={styles['multi-checkbox--count']}>
                        {countCheckedOrders(ordersDay)}
                      </span>
                      <GxButton
                        className={styles['multi-checkbox--btn']}
                        onClick={() =>
                          dispatch('changeCheckedOrder/set', 'takeOf')
                        }
                      >
                        Снять выделенное
                      </GxButton>
                    </div>
                    <div className={styles['toolbar']}>
                      <GxButton className={styles['btn']} onClick={print}>
                        <GxIcon className={styles['icon']} src={PrinterIcon} />
                        <span>Печать</span>
                      </GxButton>

                      <GxButton
                        className={styles['btn']}
                        onClick={() => handleClickCloseAndCancelOrder('close')}
                      >
                        <GxIcon className={styles['icon']} src={CloseIcon} />
                        <span>Закрыть</span>
                      </GxButton>
                      <GxButton
                        className={styles['btn']}
                        onClick={handleClickIsArrived}
                      >
                        <GxIcon
                          className={styles['icon']}
                          src={AccountCheckIcon}
                        />
                        <span>Прибыл</span>
                      </GxButton>
                    </div>
                  </>
                )}
              </>
            )}
            <GxButton
              className={styles['btn']}
              onClick={handleClickDeleteOrder}
            >
              <GxIcon className={styles['icon']} src={DeleteIcon} />
              <span>Удалить</span>
            </GxButton>
          </div>
          <div className={styles['header__right-block']}>
            <div className={styles['select']}>
              <GxIcon className={styles['icon']} src={CalendarIcon} />
              <GxSelect
                disabled={statusGetOrders}
                value={range}
                className={styles['select--dropdown']}
                onGx-change={(e: Record<string, any>) => {
                  handleClickRange(e);
                }}
              >
                <GxMenuItem value='day' active>
                  1 день
                </GxMenuItem>
                <GxMenuItem value='week'>7 дней</GxMenuItem>
              </GxSelect>
            </div>
            {rangeTableType === 'week' && (
              <>
                {typeTable === 'default' ? (
                  <GxButton
                    className={cn(styles['btn'], styles['btn--compact'])}
                    onClick={() => onChangeTypeTable('compact')}
                  >
                    Компакт
                  </GxButton>
                ) : (
                  <GxButton
                    className={cn(styles['btn'], styles['btn--compact'])}
                    onClick={() => onChangeTypeTable('default')}
                  >
                    Стандарт
                  </GxButton>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {orderModalOpen && (
        <ModalOrder flag={orderModalOpen} closeModal={toggleFlag} />
      )}
    </>
  );
};

export default ScheduleHeader;
